import React, { useState, useEffect } from 'react';
import ReactDom from 'react-dom';
import closeIcon from '../../assets/images/CloseIcon.svg';
import { CloseIconSvg } from '../ui/Svgs';

const MODAL_STYLES = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 99,
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '18px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'opacity 0.3s ease, transform 0.3s ease',
};

const OVERLAY_STYLE = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 96,
    transition: 'opacity 0.3s ease',
};

export default function ModalsWrapper({ open, children, onClose, closeIconColor, expandImage = false }) {
    const [visible, setVisible] = useState(false);
    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        if (open) {
            setVisible(true);
            setTimeout(() => setShowContent(true), 100);
        } else {
            setShowContent(false);
            const timer = setTimeout(() => setVisible(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    if (!visible) return null;

    return ReactDom.createPortal(
        <>
            <div
                style={{
                    ...OVERLAY_STYLE,
                    opacity: showContent ? 1 : 0,
                    pointerEvents: showContent ? 'auto' : 'none',
                }}
                // className='backdrop-blur-sm'
                onClick={onClose}
            ></div>
            <div
                style={{
                    ...MODAL_STYLES,
                    opacity: showContent ? 1 : 0,
                    transform: showContent ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
                    backgroundColor: expandImage ? 'transparent' : 'white',
                }}
                className="hidden-scrollbar"
            >
                {/* <img
                    onClick={onClose}
                    className={`fixed h-[16px] w-[16px] top-4 right-4 cursor-pointer ${closeIconColor}`}
                    src={closeIcon}
                    alt=""
                /> */}
                <CloseIconSvg onClick={onClose} className="fixed top-4 right-4 cursor-pointer z-[99]" fill={closeIconColor} />
                {children}
            </div>
        </>,
        document.getElementById('models-container')
    );
}